/**
 * OrdersMobileFooter Section Component
 *
 * Mobile global footer for the orders listing (Figma 15171:57014): a
 * full-width salesperson filter trigger. Replaces the desktop pagination
 * footer below the `md` breakpoint.
 */

import { cn } from '@/lib/utils';
import { MobilePillButton } from '../../../layouts/MobileButtons';
import type { OrdersMobileFooterProps } from '../types';

export type { OrdersMobileFooterProps };

export function OrdersMobileFooter({
  salespersonLabel,
  onOpenSalespersonFilter,
  className,
}: OrdersMobileFooterProps) {
  return (
    <div className={cn('flex w-full px-6 py-6', className)}>
      <MobilePillButton
        onClick={onOpenSalespersonFilter}
        className="w-full justify-center text-nav"
      >
        {salespersonLabel ?? 'Salesperson'}
      </MobilePillButton>
    </div>
  );
}
